"use strict";

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var handleChange = function handleChange(_ref) {
  var value = _ref.value,
      onCheck = _ref.onCheck,
      onChange = _ref.onChange;

  if (!value && onCheck) {
    onCheck();
  }

  onChange(!value);
};

var Toggle = function Toggle(_ref2) {
  var getClassName = _ref2.getClassName,
      disabled = _ref2.disabled,
      automationId = _ref2.automationId,
      dataHook = _ref2.dataHook,
      name = _ref2.name,
      innerInputClass = _ref2.innerInputClass,
      value = _ref2.value,
      indeterminate = _ref2.indeterminate,
      children = _ref2.children,
      onCheck = _ref2.onCheck,
      _onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement("label", {
    className: getClassName('control-boolean') + (disabled ? ' disabled' : ''),
    "data-aid": automationId,
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: getClassName('input input-' + name, innerInputClass || ''),
    checked: value,
    disabled: disabled,
    "data-indeterminate": indeterminate,
    onChange: function onChange() {
      return handleChange({
        value: value,
        onCheck: onCheck,
        onChange: _onChange
      });
    }
  }), children);
};

Toggle.displayName = displayNames.TOGGLE;
Toggle.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  onCheck: PropTypes.func
};
Toggle.defaultProps = {
  disabled: false,
  indeterminate: false
};
module.exports = compose(Toggle);